import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../styles/gallery.css";
import "../styles/common.css";

const images = [
  "/images/gallery/1.webp",
  "/images/gallery/2.webp",
  "/images/gallery/3.webp",
  "/images/gallery/4.webp",
  "/images/gallery/5.webp",
  "/images/gallery/6.webp",
  "/images/gallery/7.webp",
  "/images/gallery/8.webp",
  "/images/gallery/9.webp",
];

const Gallery = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const handlePrev = () => {
    setCurrent((prev) => (prev - 1 + images.length) % images.length);
  };

  const handleNext = () => {
    setCurrent((prev) => (prev + 1) % images.length);
  };

  return (
    <section className="carousel-gallery py-5" id="gallery">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6" data-aos="fade-right">
            <div className="gallery-description-box">
              <h2 className="modern-title">Fedezze fel rendelőnket</h2>
              <div className="orange-divider" />
              <p className="modern-description">
                Fogászatunkban modern eszközök, barátságos környezet és
                elkötelezett szakemberek várják Önt. Galériánk segítségével
                bepillantást nyerhet abba, milyen hangulatos és professzionális
                környezetben történik a kezelés.
              </p>
              <div className="clinic-location">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="#555"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="location-icon"
                  viewBox="0 0 24 24"
                >
                  <path d="M21 10.5c0 7.5-9 12.5-9 12.5s-9-5-9-12.5a9 9 0 1118 0z" />
                  <circle cx="12" cy="10.5" r="2.5" />
                </svg>
                <span>5000 Szolnok, Sólyom utca 3/A 1/1.</span>
              </div>
              <div className="clinic-phones">
                <a href="tel:+36656421719" className="clinic-phone">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="#555"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    viewBox="0 0 24 24"
                    className="phone-icon"
                  >
                    <path
                      d="M22 16.92v3a2 2 0 0 1-2.18 2
        19.79 19.79 0 0 1-8.63-3.07
        19.5 19.5 0 0 1-6-6
        19.79 19.79 0 0 1-3.07-8.67
        A2 2 0 0 1 4.11 2h3
        a2 2 0 0 1 2 1.72
        12.84 12.84 0 0 0 .7 2.81
        a2 2 0 0 1-.45 2.11L8.09 9.91
        a16 16 0 0 0 6 6
        l1.27-1.27
        a2 2 0 0 1 2.11-.45
        12.84 12.84 0 0 0 2.81.7
        A2 2 0 0 1 22 16.92z"
                    />
                  </svg>
                  <span>Fogszabályozás: 06 56 421 719</span>
                </a>

                <a href="tel:+36656220851" className="clinic-phone">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="#555"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    viewBox="0 0 24 24"
                    className="phone-icon"
                  >
                    <path
                      d="M22 16.92v3a2 2 0 0 1-2.18 2
        19.79 19.79 0 0 1-8.63-3.07
        19.5 19.5 0 0 1-6-6
        19.79 19.79 0 0 1-3.07-8.67
        A2 2 0 0 1 4.11 2h3
        a2 2 0 0 1 2 1.72
        12.84 12.84 0 0 0 .7 2.81
        a2 2 0 0 1-.45 2.11L8.09 9.91
        a16 16 0 0 0 6 6
        l1.27-1.27
        a2 2 0 0 1 2.11-.45
        12.84 12.84 0 0 0 2.81.7
        A2 2 0 0 1 22 16.92z"
                    />
                  </svg>
                  <span>Általános fogászat / Implantáció: 06 56 220 851</span>
                </a>
              </div>
            </div>
          </div>

          <div className="col-md-6" data-aos="zoom-in">
            <div className="carousel-wrapper">
              <button className="carousel-arrow left" onClick={handlePrev}>
                ❮
              </button>
              <img
                src={images[current]}
                alt={`Clinic ${current + 1}`}
                className="carousel-image"
              />
              <button className="carousel-arrow right" onClick={handleNext}>
                ❯
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
